import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../../api/ApiController';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, EditRowIcon, RefreshIcon } from "../../svg/svgIcons";
import { useReactToPrint } from "react-to-print";
import UtilContext from '../../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../../components/maintenance/MaintenanceMaskDialogCheckbox';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { buildNavigationContextFromTable } from '../../../utils/maintenanceNavigationContext';
import { useTabulatorScrollArrows } from '../../../utils/useTabulatorScrollArrows';
import { primeMultiSelectHeaderFilter } from '../../../utils/primeMultiSelectHeaderFilter';
import { cleanSorters, extractSafePaginationParams, createDedupedAjaxRequest, refreshProgressiveFromStart, safeParse, applyUserMaskRowToTabulator, mergePagedStandardListFiltersAndSorters, appendLiteralFieldTrimPagedFilter, sanitizeTabulatorLayoutAttributes, TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS } from '../../../utils/tabulatorProgressiveLoading';
import { getTabulatorPersistLayoutEvents } from '../../../utils/tabulatorPersistLayout';
import { getPusherChannel } from '../../../utils/pusherChannel';
import { getEffectiveMask } from '../../../utils/effectiveMask';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  applyDataColumnVisibilityToTable,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
  ensureMandatoryIdVisible,
} from '../../../utils/maintenanceTabulatorMaskActions';
import { inputOnEnterHeaderFilter } from '../../../utils/inputOnEnterHeaderFilter';
import { tabulatorColumnMinWidthFromTitle } from '../../../utils/tabulatorColumnMinWidth';
import { buildAuditTabulatorColumns, mergeColumnVisibilityWithAuditDefaults } from '../../../utils/tabulatorAuditColumns';
import AuthContext from '../../../components/AuthContext';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../../utils/printChrome';
import { uiT } from '../../../utils/uiTranslate';
import { applyTabulatorRuntimeI18n } from '../../../utils/tabulatorRuntimeI18n';
const MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'name': 'Common.Name',
  'machine_type.name': 'MachineList.Column.MachineTypeName',
  'template_records.length': 'MaintenanceTemplateList.Column.TaskCount',
  'description': 'Common.Description',
  'rowSelection': 'Common.Name',
});



const MASK_PAGE = 'MaintenanceTemplateRecordList';

const DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY = Object.freeze({
  id: true,
  name: true,
  'machine_type.name': true,
  'template_records.length': true,
  description: true,
  created_at: true,
  updated_at: true,
});

function mergeMaintenanceTemplateRecordListColumnVisibilityFromSaved(saved) {
  return mergeColumnVisibilityWithAuditDefaults(DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY, saved);
}

const MASK_DIALOG_HELP_TEXT =
  uiT('MaintenanceTemplateList.MaskHelp');

function applyMaintenanceTemplateRecordListDataColumnVisibility(table, visibility) {
  applyDataColumnVisibilityToTable(table, DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY, visibility);
}

function mergeMaintenanceTemplateRecordListMaskDialogVisibility(partial) {
  return ensureMandatoryIdVisible(
    mergeMaintenanceTemplateRecordListColumnVisibilityFromSaved(partial),
    DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY
  );
}

export default function MaintenanceTemplaterecordList() {
const { t, locale } = useContext(LocaleContext);

    const [state, dispatch] = useContext(DatabaseContext);
    const { setDialogText, setVisible, openFavoriteDialog, toast, setFastView, setUserMaskFilter, setStandardMaskFilter, getDateFormat, getUserColor, getUserInitials, openChosenNotificationPreferences } = useContext(UtilContext);
    const { user } = useContext(AuthContext);

    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [printVisible,setPrintVisible] = useState(false);
    const [printValue,setPrintValue] = useState("Zoznam");

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY }));
    const [maskVisible, setMaskVisible] = useState(false);

const [editFormGauge, setEditFormGauge] = useState([]);

    const ref = useRef(null);
    const elementRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);

    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const captureHScroll = useCallback(() => {
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
      if (!savedHScrollRef.current.pending) return;
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          holder.scrollLeft = left;
          if (header) header.scrollLeft = left;
          savedHScrollRef.current.pending = false;
        });
      });
    }, [getTable]);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);

    // Pusher: maintenance_template.created/updated/deleted – ako checklisty / service task
    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const onCreated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('maintenance_template.created', id)) return;
        refreshFromStart();
      };
      const onUpdated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('maintenance_template.updated', id)) return;
        getRequest(`/api/maintenance_templates/${id}`).then((res) => {
          const rowData = res?.data ?? res;
          if (!rowData?.id) return;
          const table = getTable();
          const row = table?.getRow?.(rowData.id);
          if (row) row.update(rowData);
          else table?.addData?.([rowData], true);
        }).catch(() => {});
      };
      const onDeleted = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('maintenance_template.deleted', id)) return;
        const table = getTable();
        const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
        if (row) row.delete();
      };
      channel.bind('maintenance_template.created', onCreated);
      channel.bind('maintenance_template.updated', onUpdated);
      channel.bind('maintenance_template.deleted', onDeleted);
      return () => {
        channel.unbind('maintenance_template.created', onCreated);
        channel.unbind('maintenance_template.updated', onUpdated);
        channel.unbind('maintenance_template.deleted', onDeleted);
      };
    }, [getTable, refreshFromStart]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePc;
      mergePagedStandardListFiltersAndSorters(extra, {
        getTable,
        tableBuiltForParams: tableBuiltRef.current,
        userMaskFilters: state.user_mask_filters,
        maskPage: MASK_PAGE,
        appendFilter: appendLiteralFieldTrimPagedFilter,
      });
      if (searchValue && String(searchValue).trim() !== '') extra.search = String(searchValue).trim();
      return extra;
    }, [pageSizePc, getTable, searchValue, state.user_mask_filters]);

    const ajaxRequestFunc = useMemo(
      () => createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
      [buildRequestParams]
    );

    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });

      function matchAny(data, filterParams) {
        const search = normalizeText(filterParams.value || "");
        if (!search) return true;

        for (const key in data) {
          if (normalizeText(data[key]).includes(search)) {
            return true;
          }
        }
        return false;
      }


      function searchTable() {
        setSearchIconColor("active");
        captureHScroll();
        refreshFromStart();
        setVisibleSearch(false);
      }
    
      const accept = () => {
          const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
          if (rows_to_delete.length === 0) return;
          Promise.all(rows_to_delete.map(element => deleteRequest(`/api/maintenance_templates/${element.id}`)))
            .then(() => {
              toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('MaintenanceTemplateList.Toast.DeletedDetail') });
              captureHScroll();
              refreshFromStart();
            })
            .catch(() => {
              toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
            });
      }
    
        const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
        }
    
        const confirm = () => {
            confirmDialog({
                message: t('Common.ConfirmDeleteRecord'),
                header: t('Common.ConfirmDelete'),
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: t('Common.Yes'),
                rejectLabel: t('Common.No'),
                accept,
                reject
            });
        };
    
      const rowClick = (e, row) => {
        console.log(e, row);
      };
    
      const onSelectRow = (data, rows) => {
        setEditFormGauge(data);
          if(data.length === 0){
            setInsertIcon(true);
            setEditIcon(true);
            setCopyIcon(true);
            setDeleteIcon(true);
          }
          else{
            setInsertIcon(false);
            setEditIcon(false);
            setCopyIcon(false);
            setDeleteIcon(false);
          }
      };

      const normalizeText = (value) => (value ?? "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

      function textHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // prázdny filter = všetko
        return normalizeText(rowValue).includes(normalizeText(headerValue));
      }

      function onEditRow(maintenance_template){
        const navigationContext = buildNavigationContextFromTable({ table: getTable(), cleanSorters });
        dispatch({type: 'create_new_tab', name: t('MaintenanceTemplateRecordList.Text.Ukony_k_sablone'), translationKey: 'MaintenanceTemplateRecordList.Text.Ukony_k_sablone', legacyLabel: t('MaintenanceTemplateRecordList.Text.Ukony_k_sablone'),page:'MaintenanceTemplateRecordAdd',props:{maintenance_template, type:'edit', navigationContext},mask:'mntn014'})
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }

      const dateFormatGlob = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
      const dateTimeFormatGlob = `${dateFormatGlob} HH:mm`;

      const auditColumns = useMemo(
        () =>
          buildAuditTabulatorColumns({
            includeId: true,
            idColumnOptions: { frozen: true },
            dateFormat: dateFormatGlob,
            dateTimeFormat: dateTimeFormatGlob,
            getUserColor,
            getUserInitials,
            textHeaderFilter,
          }),
        [dateFormatGlob, dateTimeFormatGlob, getUserColor, getUserInitials, textHeaderFilter]
      );
      
      const idColumn = useMemo(
        () => auditColumns.find((column) => column.field === 'id'),
        [auditColumns]
      );
      
      const createdAtColumn = useMemo(
        () => auditColumns.find((column) => column.field === 'created_at'),
        [auditColumns]
      );
      
      const updatedAtColumn = useMemo(
        () => auditColumns.find((column) => column.field === 'updated_at'),
        [auditColumns]
      );
      
      const columns = useMemo(() => [
        { title: '', field: 'rowSelection', formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, headerSort:false, resizable: false, frozen: true, print: false, download: false },
        { title: '', field: 'editor', hozAlign:"center", width: 44, headerSort:false, formatter: reactFormatter(<EditRowFormatter/>), resizable:false, frozen: true, print: false, download: false },
      
        idColumn,
      
        { title: t('Common.Name'), field: 'name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc:textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Name')), widthGrow: 1 },
        { title: t('MachineList.Column.MachineTypeName'), field: 'machine_type.name', minWidth: tabulatorColumnMinWidthFromTitle(t('MachineList.Column.MachineTypeName'), 'multiselect'), widthGrow: 1,
          headerFilter: primeMultiSelectHeaderFilter,
          headerFilterParams: { placeholder: t('Common.All'), valueType: 'string', options: (state.machine_types || []).map(mt => ({ label: mt.name, value: mt.name })) },
          headerFilterFunc: (headerValue, rowValue) => {
            if (!headerValue) return true;
            const selected = new Set(String(headerValue).split(',').map((x) => x.trim()).filter(Boolean));
            return selected.has(String(rowValue ?? ''));
          }
        },
        { title: t('MaintenanceTemplateList.Column.TaskCount'), field: "template_records.length", minWidth: tabulatorColumnMinWidthFromTitle(t('MaintenanceTemplateList.Column.TaskCount')), widthGrow: 1, headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false,
          headerFilterFunc: (headerValue, rowValue) => {
            if (!headerValue) return true;
            return String(rowValue ?? 0).includes(String(headerValue));
          }
        },
        { title: t('Common.Description'), field: 'description', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc:textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Description')), widthGrow: 1 },
      
        createdAtColumn,
        updatedAtColumn,
      ].filter(Boolean), [idColumn, createdAtColumn, updatedAtColumn, state.machine_types, textHeaderFilter]);

      const canSetStandardMask = user?.permissions?.includes('set standard mask');

      const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useTabulatorScrollArrows(getTable);

      function addNewTemplate() {
        dispatch({ type: 'create_new_tab', name: t('MaintenanceTemplateList.Tab.New'), translationKey: 'MaintenanceTemplateList.Tab.New', legacyLabel: t('MaintenanceTemplateList.Tab.New'), page: 'MaintenanceTemplateAdd', props: { maintenance_template: null, type: 'add' }, mask: 'mntn012' });
      }
      function copyTemplate() {
        const selected = getTable()?.getSelectedData?.()?.[0];
        if (selected) dispatch({ type: 'create_new_tab', name: t('MaintenanceTemplateList.Tab.New'), translationKey: 'MaintenanceTemplateList.Tab.New', legacyLabel: t('MaintenanceTemplateList.Tab.New'), page: 'MaintenanceTemplateAdd', props: { maintenance_template: selected, type: 'add' }, mask: 'mntn012' });
      }
      function editMaintenanceType() {
        const selected = getTable()?.getSelectedData?.()?.[0];
        if (!selected) return;
        const navigationContext = buildNavigationContextFromTable({ table: getTable(), cleanSorters });
        dispatch({ type: 'create_new_tab', name: t('MaintenanceTemplateRecordList.Text.Ukony_k_sablone'), translationKey: 'MaintenanceTemplateRecordList.Text.Ukony_k_sablone', legacyLabel: t('MaintenanceTemplateRecordList.Text.Ukony_k_sablone'), page: 'MaintenanceTemplateRecordAdd', props: { maintenance_template: selected, type: 'edit', navigationContext }, mask: 'mntn014' });
      }
    
    const [expandedKeys, setExpandedKeys] = useState({});

    const closeMenu = useCallback(() => {
      setTimeout(() => {
        OverflowMenuProvider.setVisible?.(null);
        setExpandedKeys({});
      }, 0);
    }, []);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


    const hasApplicableStandardMask = useMemo(
      () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, mergeMaintenanceTemplateRecordListColumnVisibilityFromSaved),
      [state.standard_mask_filters]
    );

    const openMaskDialog = useCallback(
      createOpenMaskDialog({
        columnsVisible,
        setColumnsVisible,
        defaultColumnVisibility: DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY,
        mergeVisibilityFromSaved: mergeMaintenanceTemplateRecordListColumnVisibilityFromSaved,
        setMaskVisible,
        closeMenu,
      }),
      [columnsVisible, closeMenu]
    );

    const setMask = useCallback(
      createMaskSetFieldHandler({
        defaultColumnVisibility: DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY,
        columnsVisible,
        setColumnsVisible,
        getTable,
        applyVisibilityToTable: applyMaintenanceTemplateRecordListDataColumnVisibility,
        toast,
      }),
      [columnsVisible, getTable, toast]
    );

    const maskSelectAll = useCallback(
      createMaskSelectAllHandler({
        defaultColumnVisibility: DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY,
        setColumnsVisible,
        getTable,
        applyVisibilityToTable: applyMaintenanceTemplateRecordListDataColumnVisibility,
      }),
      [getTable]
    );

    const maskDeselectAll = useCallback(
      createMaskDeselectAllHandler({
        defaultColumnVisibility: DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY,
        setColumnsVisible,
        getTable,
        applyVisibilityToTable: applyMaintenanceTemplateRecordListDataColumnVisibility,
      }),
      [getTable]
    );

    const saveUserMaskColumns = useCallback(
      createSaveUserMaskColumns({
        maskPage: MASK_PAGE,
        getTable,
        setUserMaskFilter,
        defaultColumnVisibility: DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY,
        columnsVisible,
        setColumnsVisible,
        setMaskVisible,
        toast,
      }),
      [columnsVisible, getTable, setUserMaskFilter, toast]
    );

    const confirmSaveStandardMask = useCallback(
      createConfirmSaveStandardMask({
        maskPage: MASK_PAGE,
        getTable,
        setStandardMaskFilter,
        defaultColumnVisibility: DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY,
        toast,
      }),
      [getTable, setStandardMaskFilter, toast]
    );

    const confirmApplyStandardLayoutToUserMask = useCallback(
      createConfirmApplyStandardLayoutToUserMask({
        maskPage: MASK_PAGE,
        state,
        setUserMaskFilter,
        defaultColumnVisibility: DEFAULT_MAINTENANCE_TEMPLATE_RECORD_LIST_COLUMN_VISIBILITY,
        mergeVisibilityFromSaved: mergeMaintenanceTemplateRecordListColumnVisibilityFromSaved,
        toast,
        closeMenu,
        onAppliedToTable: ({ colsForSave, attributes }) => {
          const table = getTable();
          if (!table) return;
          isRestoringRef.current = true;
          try {
            table.setColumnLayout?.(sanitizeTabulatorLayoutAttributes(attributes, TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS));
          } catch (_) {}
          setColumnsVisible({ ...colsForSave, id: true });
          applyMaintenanceTemplateRecordListDataColumnVisibility(table, { ...colsForSave, id: true });
          setTimeout(() => {
            isRestoringRef.current = false;
            table.redraw?.(true);
            captureHScroll();
            refreshFromStart();
          }, 0);
        },
      }),
      [state, closeMenu, getTable, setUserMaskFilter, toast, captureHScroll, refreshFromStart]
    );

    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );

    const handleClickOutside = (event) => {
      if (event.target.closest('[data-overflow-trigger]')) return;
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
        OverflowMenuProvider.setVisible?.(null);
      }
    };

    useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => document.removeEventListener('click', handleClickOutside, true);
    }, []);

    const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: buildMaintenanceMaskAkcieSubItems({
          maskPage: MASK_PAGE,
          getTable,
          setUserMaskFilter,
          cleanSorters,
          captureHScroll,
          refreshFromStart,
          closeMenu,
          openMaskDialog,
          openChosenNotificationPreferences,
          hasApplicableStandardMask,
          confirmApplyStandardLayoutToUserMask,
          itemRenderer,
        }),
      },
    ];

    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button onClick={() => addNewTemplate()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editMaintenanceType()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyTemplate()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor !== "active" ? () => setVisibleSearch(true) : () => { setSearchIconColor(""); setSearchValue(""); captureHScroll(); refreshFromStart(); }}>{searchIconColor === "" ? <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button onClick={() => getTable()?.download?.("xlsx", "data.xlsx", { sheetName: "MyData" })}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('MaintenanceTemplateList.FavoriteTitle'),"MaintenanceTemplateRecordList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("MaintenanceTemplateRecordList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        {canSetStandardMask ? (
          <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
            <button
              type="button"
              title={t('Common.SaveStandardMask')}
              aria-label={t('Common.SaveStandardMask')}
              onClick={confirmSaveStandardMask}
              className="flex items-center justify-center"
            >
              <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
            </button>
          </div>
        ) : null}
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    
    <div ref={elementRef}>
      <ReactTabulator
      data={undefined}
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => { ref.current = r?.current; }}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          const table = getTable();
          if (!table) return;
          const effective = getEffectiveMask(MASK_PAGE, state);
          if (effective?.type === 'user' && effective.userMask) {
            isRestoringRef.current = true;
            applyUserMaskRowToTabulator(table, effective.userMask, {
              setColumnsVisible,
              clearHeaderFiltersWhenEmpty: true,
              forceFrozenId: true,
              applyColumnVisibilityFn: (tbl, jc, setVis) => {
                const merged = mergeMaintenanceTemplateRecordListMaskDialogVisibility(jc);
                setVis(merged);
                applyMaintenanceTemplateRecordListDataColumnVisibility(tbl, merged);
              },
            });
            setTimeout(() => { isRestoringRef.current = false; }, 0);
          } else if (effective?.type === 'standard' && effective.standardMask) {
            isRestoringRef.current = true;
            const m = effective.standardMask;
            const attributes = safeParse(m.attributes, []);
            const jsonColumns = safeParse(m.columns, {});
            if (Array.isArray(attributes) && attributes.length > 1) {
              table.setColumnLayout?.(sanitizeTabulatorLayoutAttributes(attributes, TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS));
            }
            if (jsonColumns && typeof jsonColumns === 'object') {
              const merged = mergeMaintenanceTemplateRecordListMaskDialogVisibility(jsonColumns);
              setColumnsVisible(merged);
              applyMaintenanceTemplateRecordListDataColumnVisibility(table, merged);
            }
            setTimeout(() => { isRestoringRef.current = false; }, 0);
          }
          tableBuiltRef.current = true;
          if (effective?.type === 'user') refreshFromStart();
        },
        ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
        headerFilterChanged: () => { if (!isRestoringRef.current) captureHScroll(); },
        sortChanged: () => { if (!isRestoringRef.current) captureHScroll(); },
        renderComplete: () => { restoreHScroll(); if (getTable()?.getSelectedData()?.length === 0) { setEditIcon(true); setCopyIcon(true); setDeleteIcon(true); } },
      }}
      options={{
        layout: "fitColumns",
        movableColumns: true,
        rowHeight: 42,
        printAsHtml:true,printHeader: () => buildCanonicalPrintHeaderHtml({
                      branding: state?.branding,
                      productFallbackSrc: defaultProductLogoSrc,
                      companySettingsPrint: state?.company_settings_print,
                      moduleSettings: state?.module_settings,
                      title: t('Print.Title.MaintenanceTemplateRecordList'),
                      printDateLabel: t('Print.DateLabel'),
                    }),
                    printFooter: () => buildCanonicalPrintFooterHtml({
                      companySettingsPrint: state?.company_settings_print,
                    }),
        printRowRange: "active",
        ajaxURL: "/api/maintenance_templates/paged",
        ajaxRequestFunc,
        filterMode: "remote",
        sortMode: "remote",
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        pagination: false,
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingEllipsis'),
        dataLoaderError: t('Common.LoadFailed'),
      }}/>
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
            <div className="flex flex-col">
              <p className="text-sm text-gray-600 mb-2">{MASK_DIALOG_HELP_TEXT}</p>
              <div className="flex flex-wrap gap-2 mb-2">
                <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
                <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
              </div>
              {columns.map((item) => {
                if (!item?.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
                const field = String(item.field);
                const inputId = `${MASK_PAGE}-${field}`;
                return (
                  <div key={field} className="flex flex-row border border-black rounded-md p-2 m-1">
                    <MaintenanceMaskDialogCheckbox field={field} inputId={inputId} title={item.title} columnsVisible={columnsVisible} onChange={setMask} />
                    <label htmlFor={inputId} className={`ml-2 ${field === 'id' ? '' : 'cursor-pointer'}`}>{item.title}</label>
                  </div>
                );
              })}
              <button type="button" onClick={saveUserMaskColumns} className="m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700">{t('Common.SaveUpper')}</button>
            </div>
          </Dialog>
</div> 
        </>
    )
}